import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import BoardOfAdvisors from "@/pages/BoardOfAdvisors";

export const Route = createFileRoute("/board-of-advisors")({
  head: () => buildRouteHead("/board-of-advisors"),
  component: BoardOfAdvisors,
});

